import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  private analyticsUrl = '/analytics/v1/admin-dashboard';

  constructor(private http: HttpClient) {}

  getAdminAnalytics(filters: {
    locationId?: number | null;
    status?: string | null;
    scheduleType?: string | null;
    fromDate?: string | null;
    toDate?: string | null;
  }) {
    let params = new HttpParams();
    if (filters.locationId != null) {
      params = params.append('locationId', filters.locationId);
    }
    if (filters.status) {
      params = params.append('status', filters.status);
    }
    if (filters.scheduleType) {
      params = params.append('scheduleType', filters.scheduleType);
    }
    if (filters.fromDate) {
      params = params.append('fromDate', filters.fromDate);
    }
    if (filters.toDate) {
      params = params.append('toDate', filters.toDate);
    }
    return this.http.get<any>(this.analyticsUrl, { params });
  }
}
